import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutUs from "../pages/about-us/page";
import Products from "../pages/products/page";
import Quality from "../pages/quality/page";
import Sustainability from "../pages/sustainability/page";
import GlobalReach from "../pages/global-reach/page";
import Contact from "../pages/contact/page";
import AdminPage from "@/pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/quality",
    element: <Quality />,
  },
  {
    path: "/sustainability",
    element: <Sustainability />,
  },
  {
    path: "/global-reach",
    element: <GlobalReach />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
